<i18n locale="en">
{
  "alt": {
    "appStore": "Download on the App Store",
    "googlePlay": "Get it on Google Play"
  }
}
</i18n>

<template>
  <PreviewSheet
    radius="0"
    background="primary"
    class="get-the-app-buttons-preview"
  >
    <div class="get-the-app-buttons-preview__row">
      <a
        v-if="hasAppStore"
        class="get-the-app-buttons-preview__link"
        href="#"
        @click.prevent
      >
        <img
          :alt="t('alt.appStore')"
          class="get-the-app-buttons-preview__img"
          :src="IOS_STORE_ICON"
        />
      </a>
      <a
        v-if="hasPlayStore"
        class="get-the-app-buttons-preview__link"
        href="#"
        @click.prevent
      >
        <img
          :alt="t('alt.googlePlay')"
          class="get-the-app-buttons-preview__img"
          :src="ANDROID_STORE_ICON"
        />
      </a>
    </div>
  </PreviewSheet>
</template>

<script lang="ts" setup>
import { computed, inject } from 'vue'
import { useI18n } from 'vue-i18n'

import PreviewSheet from '@/lib/builder/public/preview/PreviewSheet.vue'
import globalStore from '@/store'

import { getBrandAppPlatforms } from '../../../composables/useBrandHasApp'

const { t } = useI18n()

const storeModule = inject<string>('storeModule')
const currentResource = computed(
  () => storeModule && globalStore.getters[`${storeModule}/currentResource`]
)
const platforms = computed(() =>
  getBrandAppPlatforms(currentResource.value?.brandId)
)
const hasAppStore = computed(() => platforms.value?.hasAppStore ?? false)
const hasPlayStore = computed(() => platforms.value?.hasPlayStore ?? false)

// Official badges: use apple.svg and google.svg in public/static/app-stores/ (see README there)
const IOS_STORE_ICON = '/static/app-stores/apple.svg'
const ANDROID_STORE_ICON = '/static/app-stores/google.svg'
</script>

<style lang="scss" scoped>
.get-the-app-buttons-preview {
  padding: 12px 16px;

  &__row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }

  &__link {
    display: block;
    line-height: 0;
  }

  &__img {
    display: block;
    height: 48px;
    width: auto;
    border: 0;
  }
}
</style>
